// extracted by mini-css-extract-plugin
module.exports = {"left":"splitter_left__IS3R1","right":"splitter_right__j7cNr","inner":"splitter_inner__vUMrk","resizing":"splitter_resizing__z_Bi8","move-overlay":"splitter_move-overlay__34u_j"};